import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a806966bedae70014908cd3_1788343011605_b342072a/privateluxuryworld/src/app/cookie-policy/page.tsx");
